import { useEffect, useRef } from 'react';
import confetti from '../../assets/video/confetti.webm';

import styles from './Confetti.module.css';

export const Confetti = ({ startDelay = 2000 }) => {
  const confettiRef = useRef(null);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, startDelay);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, []);

  return (
    <div className={styles.confettiVideo}>
      <video ref={confettiRef} muted="muted" loop playsInline>
        <source src={confetti} type="video/webm"></source>
      </video>
    </div>
  );
};
